import { memo } from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Clipboard from "ui/molecules/Clipboard";
import Label from "./Label";
import type { PaymentMethodCountriesProps } from "./types";

const PaymentMethodCountries = ({ slotProps, forCountries }: PaymentMethodCountriesProps) => (
    <Label
        title='Countries'
        {...slotProps?.label}
    >
        <Tooltip
            title={forCountries}
            {...slotProps?.tooltip}
        >
            <Box
                sx={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer'
                }}
            >
                <Clipboard
                    sx={{
                        fontWeight: 700
                    }}
                >
                    {forCountries}
                </Clipboard>
            </Box>
        </Tooltip>
    </Label>
);

export default memo(PaymentMethodCountries);